let smartCartTotal;
(self.webpackChunkyourkaya = self.webpackChunkyourkaya || []).push([
  [5090],
  {
    8978: function () {
      var t = Object.defineProperty,
        e = Object.defineProperties,
        r = Object.getOwnPropertyDescriptors,
        n = Object.getOwnPropertySymbols,
        i = Object.prototype.hasOwnProperty,
        o = Object.prototype.propertyIsEnumerable,
        a = (e, r, n) =>
          r in e
            ? t(e, r, {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: n,
              })
            : (e[r] = n),
        c = (t, e) => {
          for (var r in e || (e = {})) i.call(e, r) && a(t, r, e[r]);
          if (n) for (var r of n(e)) o.call(e, r) && a(t, r, e[r]);
          return t;
        },
        d = (t, e, r) =>
          new Promise((n, i) => {
            var o = (t) => {
                try {
                  c(r.next(t));
                } catch (t) {
                  i(t);
                }
              },
              a = (t) => {
                try {
                  c(r.throw(t));
                } catch (t) {
                  i(t);
                }
              },
              c = (t) => (t.done ? n(t.value) : Promise.resolve(t.value).then(o, a));
            c((r = r.apply(t, e)).next());
          });
      function u() {
        Rebuy.SmartCart.show();
      }
      function s(t) {
        var e, r;
        const n =
            null == (r = null == (e = null == Rebuy ? void 0 : Rebuy.Cart) ? void 0 : e.cart) ? void 0 : r.item_count,
          { dataset: i } = t;
        0 === n ? (i.cartIcon = '') : void 0 !== n && (i.cartIcon = n);
      }
      function l() {
        const t = Rebuy.Cart.cart.items;
        t.filter((t) => {
          var e;
          return null == (e = null == t ? void 0 : t.properties) ? void 0 : e._product_refile;
        }).forEach((e) => {
          const r = Number(e.properties._product_refile),
            n = t.reduce((t, e) => (e.id === r ? t + e.quantity : t), 0);
          if (n < e.quantity) {
            const t = e.key;
            fetch(`${Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: t, quantity: n }),
            }).finally(
              (function (t, e) {
                if (!t || !e) return !1;
                const r = document.getElementById(`refill_warning_${t}`);
                return (
                  !!r &&
                  !!window.getShemaDataItem('refill_warning') &&
                  (r.classList.add('open'), setTimeout(() => r.classList.remove('open'), 3e3), !0)
                );
              })(t, n)
            );
          }
        });
      }

      function clearLocalStorage() {
        localStorage.removeItem('discountCode');
      }

      function applyDiscount(code) {
        fetch('/payments/config', { method: 'GET' })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            const checkout_json_url = '/wallets/checkouts/';
            const authorization_token = btoa(data.paymentInstruments.accessToken);

            fetch('/cart.js', {})
              .then(function (res) {
                return res.json();
              })
              .then(function (cartData) {
                let body = {
                  checkout: {
                    country: Shopify.country,
                    discount_code: code,
                    line_items: cartData.items,
                    presentment_currency: Shopify.currency.active,
                  },
                };

                fetch(checkout_json_url, {
                  headers: {
                    accept: '*/*',
                    'cache-control': 'no-cache',
                    authorization: 'Basic ' + authorization_token,
                    'content-type': 'application/json, text/javascript',
                    pragma: 'no-cache',
                    'sec-fetch-dest': 'empty',
                    'sec-fetch-mode': 'cors',
                    'sec-fetch-site': 'same-origin',
                  },
                  referrerPolicy: 'strict-origin-when-cross-origin',
                  method: 'POST',
                  mode: 'cors',
                  credentials: 'include',
                  body: JSON.stringify(body),
                })
                  .then(function (response) {
                    return response.json();
                  })
                  .then(function (checkoutData) {
                    if (checkoutData.checkout && checkoutData.checkout.applied_discounts.length > 0) {
                      let discountApplyUrl = '/discount/' + code + '?v=' + Date.now() + '&redirect=/checkout/';

                      return fetch(discountApplyUrl, {})
                        .then(function (response) {
                          return response.text();
                        })
                        .then(function () {
                          let localStorageValue = {
                            code: code.trim(),
                            totalCart: checkoutData.checkout.total_line_items_price,
                          };
                          localStorage.setItem('discountCode', JSON.stringify(localStorageValue));

                          return Rebuy.Cart.fetchCart();
                        });
                    } else {
                      clearLocalStorage();
                      return Promise.reject('Discount not applied');
                    }
                  })
                  .catch(function (error) {
                    console.error('Error applying discount:', error);
                  });
              });
          });
      }

      const convertDotPriceToComaPrice = (price) => {
        let originalPrice = (price / 100).toFixed(2);
        let convertedPrice = originalPrice.replace('.', ',');
        return convertedPrice + ' zł';
      };

      const reduceChars = (elementsArr, maxlength) => {
        if (elementsArr.length) {
          elementsArr.forEach((d) => {
            const text = d.innerText;
            const textLength = text.length;
            if (maxlength <= textLength) {
              d.innerText = text.slice(0, maxlength) + '...';
            }
          });
        }
      };

      const handleUpdateTamponsProperties = () => {
        const products = document.querySelectorAll('.product-tampony');
        const bundles = document.querySelectorAll(
          '.product-zestaw-2x-podpaski-na-dzien-1x-na-noc-wkladki-tampony-plyn'
        );

        const updateProperties = (element) => {
          const miniProperty = element.querySelector('.property-key-mini');
          const regularProperty = element.querySelector('.property-key-regular');
          const superProperty = element.querySelector('.property-key-super');
          const miniSpanProperty = element.querySelector('.property-key-mini .mini');
          const regularSpanProperty = element.querySelector('.property-key-regular .regular');
          const superSpanProperty = element.querySelector('.property-key-super .super');

          if (miniProperty && !miniSpanProperty) {
            miniProperty.insertAdjacentHTML('afterbegin', `<span class="mini">mini: </span>`);
          }
          if (regularProperty && !regularSpanProperty) {
            regularProperty.insertAdjacentHTML('afterbegin', `<span class="regular">regular: </span>`);
          }
          if (superProperty && !superSpanProperty) {
            superProperty.insertAdjacentHTML('afterbegin', `<span class="super">super: </span>`);
          }
        };

        products.forEach((product) => {
          updateProperties(product);
        });

        bundles.forEach((bundle) => {
          updateProperties(bundle);
        });
      };

      const updateCartHeaderPadding = (height) => {
        const element = document.getElementById('sticky-delivery');
        const root = document.getElementById('rebuy-cart');
        root?.style.setProperty('--header-height', (height || element.scrollHeight) + 'px');
      };

      const displayCrossedPriceInProductsList = () => {
        Rebuy.Cart.cart.items.forEach((item) => {
          const itemElements = document.querySelectorAll(`.product-${item?.product?.handle}`);

          itemElements.forEach((itemElement) => {
            const currentDisplayedPrice = itemElement.querySelector('.rebuy-money.sale')?.innerText.trim();

            const cartPrice = convertDotPriceToComaPrice(item.discounted_price);

            const shouldApplyPrice = currentDisplayedPrice === cartPrice || !currentDisplayedPrice;

            if (shouldApplyPrice) {
              const isSubscription = itemElement.classList.contains('property-value-rebuy-switch-to-subscription');

              const priceWrapper = itemElement.querySelector(`.rebuy-cart__flyout-item-price div`);

              if (!priceWrapper) return;

              let originalPrice = priceWrapper.querySelector('span.original-price');
              if (originalPrice) {
                originalPrice.remove();
              }

              if (Rebuy.SmartCart.cart.total_discount > 0) {
                if (isSubscription) {
                  if (item.selling_plan_allocation) {
                    if (item.discounted_price < item.price) {
                      priceWrapper.insertAdjacentHTML(
                        'beforeend',
                        `<span class="original-price">${convertDotPriceToComaPrice(
                          item.selling_plan_allocation.price
                        )}</span>`
                      );
                    } else {
                      priceWrapper.insertAdjacentHTML(
                        'beforeend',
                        `<span class="original-price">${convertDotPriceToComaPrice(
                          item.selling_plan_allocation.compare_at_price
                        )}</span>`
                      );
                    }
                  } else {
                    priceWrapper.insertAdjacentHTML(
                      'beforeend',
                      `<span class="original-price">${convertDotPriceToComaPrice(item.price)}</span>`
                    );
                  }
                } else {
                  if (item.selling_plan_allocation) {
                    if (item.discounted_price < item.price) {
                      priceWrapper.insertAdjacentHTML(
                        'beforeend',
                        `<span class="original-price">${convertDotPriceToComaPrice(item.price)}</span>`
                      );
                    }
                  } else {
                    if (item.discounted_price < item.price) {
                      priceWrapper.insertAdjacentHTML(
                        'beforeend',
                        `<span class="original-price">${convertDotPriceToComaPrice(item.price)}</span>`
                      );
                    }
                  }
                }
              } else {
                if (isSubscription) {
                  if (item.selling_plan_allocation) {
                    priceWrapper.insertAdjacentHTML(
                      'beforeend',
                      `<span class="original-price">${convertDotPriceToComaPrice(
                        item.selling_plan_allocation.compare_at_price
                      )}</span>`
                    );
                  } else {
                    priceWrapper.insertAdjacentHTML(
                      'beforeend',
                      `<span class="original-price">${convertDotPriceToComaPrice(item.price)}</span>`
                    );
                  }
                } else {
                  if (item.selling_plan_allocation) {
                    if (item.discounted_price < item.price) {
                      priceWrapper.insertAdjacentHTML(
                        'beforeend',
                        `<span class="original-price">${convertDotPriceToComaPrice(item.price)}</span>`
                      );
                    }
                  } else {
                    if (item.discounted_price < item.price) {
                      priceWrapper.insertAdjacentHTML(
                        'beforeend',
                        `<span class="original-price">${convertDotPriceToComaPrice(item.price)}</span>`
                      );
                    }
                  }
                }
              }
            }
          });
        });
      };

      const displayOriginalPriceInProductList = () => {
        Rebuy.Cart.cart.items.forEach((item) => {
          const hasAnyDiscount = Array.isArray(item?.discounts) && item.discounts.length > 0;
          if (hasAnyDiscount) return;

          const itemElements = document.querySelectorAll(`.product-${item?.product?.handle}`);

          itemElements.forEach((itemElement) => {
            const currentDisplayedPrice = itemElement.querySelector('.rebuy-money.sale')?.innerText.trim();

            const cartPrice = convertDotPriceToComaPrice(item.discounted_price);

            const shouldApplyPrice = currentDisplayedPrice === cartPrice || !currentDisplayedPrice;

            if (shouldApplyPrice) {
              const isSubscription = itemElement.classList.contains('property-value-rebuy-switch-to-subscription');

              const priceWrapper = itemElement.querySelector(`.rebuy-cart__flyout-item-price div`);

              if (!priceWrapper) return;

              let originalPrice = priceWrapper.querySelector('.rebuy-money.sale');

              if (Rebuy.SmartCart.cart.total_discount > 0) {
                if (isSubscription) {
                  if (item.selling_plan_allocation) {
                    if (item.discounted_price < item.price) {
                      if (originalPrice)
                        originalPrice.innerText = convertDotPriceToComaPrice(item.selling_plan_allocation.price);
                    } else if (item.discounted_price === item.price) {
                      if (originalPrice) originalPrice.innerText = convertDotPriceToComaPrice(item.price);
                    } else {
                      if (originalPrice)
                        originalPrice.innerText = convertDotPriceToComaPrice(
                          item.selling_plan_allocation.compare_at_price
                        );
                    }
                  }
                } else {
                  if (item.selling_plan_allocation) {
                    if (item.discounted_price < item.price) {
                      if (originalPrice) originalPrice.innerText = convertDotPriceToComaPrice(item.price);
                    }
                  } else {
                    if (item.discounted_price < item.price) {
                      if (originalPrice) originalPrice.innerText = convertDotPriceToComaPrice(item.price);
                    }
                  }
                }
              } else {
                if (isSubscription) {
                  if (item.selling_plan_allocation) {
                    if (originalPrice)
                      originalPrice.innerText = convertDotPriceToComaPrice(item.selling_plan_allocation.price);
                  }
                } else {
                  if (item.selling_plan_allocation) {
                    if (item.discounted_price < item.price) {
                      if (originalPrice) originalPrice.innerText = convertDotPriceToComaPrice(item.price);
                    }
                  } else {
                    if (item.discounted_price < item.price) {
                      if (originalPrice) originalPrice.innerText = convertDotPriceToComaPrice(item.price);
                    }
                  }
                }
              }
            }
          });
        });
      };

      const handleAddElementsToSellingPlanTitles = () => {
        setTimeout(() => {
          const subscriptionSellingPlanTitle = document.querySelector(
            '.rebuy-cart__flyout-selling-plan-title.subscription'
          );
          const onetimeSellingPlanTitle = document.querySelector(
            '#one-time-purchase-plan.rebuy-cart__flyout-selling-plan-title'
          );

          if (subscriptionSellingPlanTitle && onetimeSellingPlanTitle) {
            if (!subscriptionSellingPlanTitle.querySelector('div.yk-custom-icon')) {
              subscriptionSellingPlanTitle.insertAdjacentHTML('afterbegin', `<div class="yk-custom-icon">⏱️</div>`);
            }

            if (!onetimeSellingPlanTitle.querySelector('div.yk-custom-icon')) {
              onetimeSellingPlanTitle.insertAdjacentHTML('afterbegin', `<div class="yk-custom-icon">🛍️</div>`);
            }

            if (!subscriptionSellingPlanTitle.querySelector('span') && !onetimeSellingPlanTitle.querySelector('span')) {
              subscriptionSellingPlanTitle.insertAdjacentHTML('beforeend', `<span></span>`);
              onetimeSellingPlanTitle.insertAdjacentHTML('beforeend', `<span></span>`);
            }
          }
        }, 100);
      };

      const handleSellingPlanTitles = () => {
        const subscriptionSellingPlanTitle = document.querySelector(
          '.rebuy-cart__flyout-selling-plan-title.subscription'
        );
        const onetimeSellingPlanTitle = document.querySelector(
          '#one-time-purchase-plan.rebuy-cart__flyout-selling-plan-title'
        );
        const subscriptionsCount = document.querySelector('.rebuy-cart__flyout-selling-plan-title.subscription span');
        const onetimesCount = document.querySelector(
          '#one-time-purchase-plan.rebuy-cart__flyout-selling-plan-title span'
        );

        const isSubscription = Rebuy.SmartCart.cart.items.some((item) =>
          item.hasOwnProperty('selling_plan_allocation')
        );

        if (subscriptionSellingPlanTitle && onetimeSellingPlanTitle) {
          if (!isSubscription && subscriptionSellingPlanTitle) {
            subscriptionSellingPlanTitle.style.display = 'none';
            onetimeSellingPlanTitle.style.marginTop = '10px';
          } else if (isSubscription && subscriptionSellingPlanTitle) {
            subscriptionSellingPlanTitle.style.display = 'flex';
          }

          let onetimes = 0;
          let subs = 0;
          Rebuy.SmartCart.cart.items.forEach((item) => {
            if (item.hasOwnProperty('selling_plan_allocation')) {
              subs += item.quantity;
            } else {
              onetimes += item.quantity;
            }
          });

          if (onetimes === 0) {
            onetimeSellingPlanTitle.style.display = 'none';
          } else {
            onetimeSellingPlanTitle.style.display = 'flex';
          }

          if (subscriptionsCount) subscriptionsCount.innerText = `(${subs})`;
          if (onetimesCount) onetimesCount.innerText = `(${onetimes})`;
        }
      };

      const handleDisplayPromotionBar = () => {
        const customProductPromotionLabels = document.querySelectorAll('.yk-promotion-label');
        customProductPromotionLabels.forEach((el) => el.remove());

        const itemElements = document.querySelectorAll(`.tag-dwaplusjedenolejki:not(.rebuy-carousel__slide)`);
        itemElements.forEach((itemElement) => {
          const existingLabel = itemElement?.querySelector('.yk-promotion-label');

          if (!existingLabel) {
            itemElement.insertAdjacentHTML(
              'beforeend',
              `<span class="yk-promotion-label">Dodaj 3 produkty do ust i odbierz 1 <b>GRATIS!</b></span>`
            );
          }
        });

        const uniqueDiscountTitles = new Set();

        Rebuy.SmartCart.cart.items.forEach((item) => {
          item.discounts.forEach((discount) => {
            uniqueDiscountTitles.add(discount.title);
          });
        });

        let discountsArray = Array.from(uniqueDiscountTitles);
        const discountsWrapper = document.querySelector('.yk-discounts-labels');

        if (discountsWrapper) {
          discountsWrapper.innerHTML = '';
        }

        let olejekPromotionQuantity = 0;

        Rebuy.SmartCart.cart.items.forEach((item) => {
          if (item.product?.tags?.includes('olejek-promocja')) {
            olejekPromotionQuantity += item.quantity;
          }
        });

        if (olejekPromotionQuantity >= 3) {
          if (discountsWrapper) {
            discountsWrapper.style.padding = '8px 14px';
            discountsArray.forEach((discount) => {
              discountsWrapper.insertAdjacentHTML(
                'afterbegin',
                `<div>
                        <img src="https://cdn.shopify.com/s/files/1/0593/6902/9684/files/price-label.png?v=1708683235" width="10px" height="10px"/>${discount}
                      </div>`
              );
            });
          }
        }
      };

      const rebuyUpdateValuesAfterDiscount = () => {
        const checkCodeIsAdded = () => {
          const productVariantsTitle = document.querySelectorAll('.rebuy-cart__flyout-item-variant-title');

          const bundleItemTitle = document.querySelectorAll('.rebuy-cart__flyout-item-property-value');

          const productDescriptions = document.querySelectorAll('.rebuy-product-description');

          const footerProductsSummaryAmount = document.querySelector(
            '.rebuy-cart__flyout-footer .yk-custom-products-summary .rebuy-cart__flyout-subtotal-amount .rebuy-cart__flyout-subtotal-compare-amount'
          );

          const totalRowAmount = document.querySelector('.rebuy-cart__flyout-subtotal-amount.total-row--amount');

          const footerDeliveryPrice = document.querySelector(
            '.rebuy-cart__flyout-footer .rebuy-cart__flyout-subtotal-amount--delivery-price'
          );

          const messageBar = document.querySelector('.rebuy-cart__flyout-shipping-bar-message');

          const discountInput = document.getElementById('rebuy-discount-input');
          if (discountInput) discountInput.setAttribute('placeholder', 'Wpisz kod rabatowy');

          reduceChars(productDescriptions, 50);
          reduceChars(productVariantsTitle, 50);
          reduceChars(bundleItemTitle, 50);
          handleSellingPlanTitles();
          handleUpdateTamponsProperties();
          handleDigitalProducts();

          const hasFreeShipping = Rebuy.SmartCart.hasFreeShipping();
          if (hasFreeShipping || Rebuy.SmartCart.cart.total_price / 100 > window.ykFreeShipping) {
            if (messageBar) {
              messageBar.innerHTML = 'Super! Masz darmową dostawę!';
            }
          }

          const codeWrapperSpan = document.querySelector('.rebuy-cart__flyout-tag span:nth-child(2)');
          if (Rebuy.SmartCart.discount?.amount > 0 && Rebuy.SmartCart.cart.total_discount > 0) {
            codeWrapperSpan.innerText = `-${convertDotPriceToComaPrice(Rebuy.SmartCart.cart.total_discount)}`;
          }

          if (
            !Rebuy.SmartCart.discount?.discount &&
            !Rebuy.SmartCart.discount?.loading &&
            !Rebuy.SmartCart.discount?.error
          ) {
            clearInterval(codeIsAddedInterval);

            if (Rebuy.SmartCart.cart.total_discount > 0 && footerProductsSummaryAmount) {
              footerProductsSummaryAmount.style.display = 'flex';
            }

            if (Rebuy.SmartCart.cart.total_price / 100 > window.ykFreeShipping || hasFreeShipping) {
              if (Rebuy.SmartCart.cart.total_discount === 0 && !Rebuy.SmartCart.discount?.code) {
                if (totalRowAmount) {
                  totalRowAmount.innerHTML = `<span>${convertDotPriceToComaPrice(
                    Rebuy.SmartCart.cart.total_price
                  )}</span>`;
                }
              }

              if (Rebuy.SmartCart.cart.total_discount === 0 && footerProductsSummaryAmount) {
                if (totalRowAmount) {
                  totalRowAmount.innerHTML = `<span>${convertDotPriceToComaPrice(
                    Rebuy.SmartCart.cart.total_price
                  )}</span>`;
                }
              } else if (Rebuy.SmartCart.cart.total_discount > 0 && footerProductsSummaryAmount) {
                if (totalRowAmount) {
                  totalRowAmount.innerHTML = `
                  <span class="crossed-price">${convertDotPriceToComaPrice(
                    Rebuy.SmartCart.cart.original_total_price
                  )}</span>
                  <span>${convertDotPriceToComaPrice(Rebuy.SmartCart.cart.total_price)}</span>`;
                }

                footerProductsSummaryAmount.innerHTML = `<span class="crossed-price hh">${convertDotPriceToComaPrice(
                  Rebuy.SmartCart.cart.original_total_price
                )}</span>`;
              }
            } else {
              if (Rebuy.SmartCart.cart.total_discount === 0 && !Rebuy.SmartCart.discount?.code) {
                if (totalRowAmount) {
                  totalRowAmount.innerHTML = `<span>${convertDotPriceToComaPrice(
                    Rebuy.SmartCart.cart.total_price + 1599
                  )}</span>`;
                }
              }

              if (Rebuy.SmartCart.cart.total_discount === 0 && footerProductsSummaryAmount) {
                if (totalRowAmount) {
                  totalRowAmount.innerHTML = `<span>${convertDotPriceToComaPrice(
                    Rebuy.SmartCart.cart.total_price + 1599
                  )}</span>`;
                }
              } else if (Rebuy.SmartCart.cart.total_discount > 0 && footerProductsSummaryAmount) {
                if (totalRowAmount) {
                  totalRowAmount.innerHTML = `
                  <span class="crossed-price kk">${convertDotPriceToComaPrice(
                    Rebuy.SmartCart.cart.original_total_price + 1599
                  )}</span>
                  <span>${convertDotPriceToComaPrice(Rebuy.SmartCart.cart.total_price + 1599)}</span>`;
                }
                footerProductsSummaryAmount.innerHTML = `<span class="crossed-price jj">${convertDotPriceToComaPrice(
                  Rebuy.SmartCart.cart.original_total_price
                )}</span>`;
              }
            }
          } else if (Rebuy.SmartCart.discount?.code) {
            clearInterval(codeIsAddedInterval);
            const discountWrapper = document.querySelector('.rebuy-cart__flyout-discount--amount');

            if (Rebuy.SmartCart.discount?.amount > 0 && footerProductsSummaryAmount) {
              discountWrapper.style.display = 'flex';
              footerProductsSummaryAmount.style.display = 'flex';
            }

            const discountLabel = document.querySelector(
              '.rebuy-cart__flyout-discount-amount .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-label span'
            );

            discountLabel.innerText = `Kod rabatowy ${Rebuy.SmartCart.discount?.code}`;

            const codeWrapperSpan = document.querySelector('.rebuy-cart__flyout-tag span:nth-child(2)');

            if (Rebuy.SmartCart.discount.amount > 0 && Rebuy.SmartCart.cart.total_discount > 0) {
              codeWrapperSpan.innerText = `-${convertDotPriceToComaPrice(Rebuy.SmartCart.cart.total_discount)}`;
            } else if (Rebuy.SmartCart.discount.amount > 0 && Rebuy.SmartCart.cart.total_discount === 0) {
              codeWrapperSpan.innerText = `-${convertDotPriceToComaPrice(Rebuy.SmartCart.discount.amount)}`;
            } else if (Rebuy.SmartCart.cart.total_discount > 0) {
              codeWrapperSpan.innerText = `-${convertDotPriceToComaPrice(Rebuy.SmartCart.cart.total_discount)}`;
            }

            if (Rebuy.SmartCart.cart.total_price / 100 > window.ykFreeShipping || hasFreeShipping) {
              if (footerProductsSummaryAmount) {
                footerProductsSummaryAmount.innerHTML = `
                    <span class="crossed-price cc">${convertDotPriceToComaPrice(
                      Rebuy.SmartCart.cart.original_total_price
                    )}</span>`;

                if (totalRowAmount)
                  totalRowAmount.innerHTML = `
                     <span class="crossed-price dd">${convertDotPriceToComaPrice(
                       Rebuy.SmartCart.cart.original_total_price
                     )}</span>
                     <span>${convertDotPriceToComaPrice(
                       Rebuy.SmartCart.cart.original_total_price - Rebuy.SmartCart.cart.total_discount
                     )}</span>`;
              }
            } else {
              if (footerProductsSummaryAmount) {
                footerProductsSummaryAmount.innerHTML = `
                    <span class="crossed-price oo ">${convertDotPriceToComaPrice(
                      Rebuy.SmartCart.cart.original_total_price
                    )}</span>`;

                if (totalRowAmount)
                  totalRowAmount.innerHTML = `
                     <span class="crossed-price pp">${convertDotPriceToComaPrice(
                       Rebuy.SmartCart.cart.original_total_price + 1599
                     )}</span>
                     <span>${convertDotPriceToComaPrice(
                       Rebuy.SmartCart.cart.original_total_price - Rebuy.SmartCart.cart.total_discount + 1599
                     )}</span>`;
              }
            }
          }

          addDiscountListeners();
        };
        const codeIsAddedInterval = setInterval(checkCodeIsAdded, 100);
      };

      const addDiscountListeners = () => {
        const addNewDiscountButton = document.querySelector('.cart-discount-input-container button.rebuy-button');

        if (addNewDiscountButton) {
          addNewDiscountButton.addEventListener('click', () => {
            const discountInputValue = document.querySelector('#rebuy-discount-input').value;
            rebuyUpdateValuesAfterDiscount();
            applyDiscount(discountInputValue);
          });
        }

        const codeLabelButton = document.querySelector('.rebuy-cart__flyout-tag');
        if (codeLabelButton) {
          codeLabelButton.addEventListener('click', () => {
            rebuyUpdateValuesAfterDiscount();
          });
        }
      };

      const cartData = JSON.parse(document.getElementById('SmartCartJson').textContent);

      let additionalSteps = [];
      if (cartData?.global_promo_config) {
        additionalSteps = cartData.global_promo_config.thresholds;
      }

      const discountTiers = [{ discount: 0, amount: 0 }, ...additionalSteps];

      const updateProgressBar = () => {
        setTimeout(() => {
          const progressWrapper = document.querySelector('.progress');
          if (!progressWrapper) return null;
          const progressBar = document.getElementById('progress-bar');
          const discountGapElem = document.querySelectorAll('.discount-gap');

          const currentDiscountElem = document.getElementById('current-discount');
          const nextDiscountElem = document.getElementById('next-discount');

          const discountTotalValue = document.getElementById('bw-total_discount');
          const milestoneElems = document.querySelectorAll('.milestone');
          const progressInfoPrices = document.getElementById('progress-info-prices');

          const progressInfoText = progressWrapper?.querySelector('.progress-info');
          const progressInfoEmpty = progressWrapper?.querySelector('.progress-empty');
          const progressInfoFull = progressWrapper?.querySelector('.progress-full');

          const progressTitle = progressWrapper?.querySelector('.progress-title span');
          const schemaProgressInfo = progressWrapper?.querySelector('.schema-progress-info p');

          const ANOTHER_Gift = 'oraz kolejny prezent';
          const JUST_Gift = 'oraz prezent';

          const schema = [
            {
              threshold: 0,
              title: 'Ruszaj po zniżki i prezent!',
              description: 'Dodaj produkty za min. 75 zł, by zgarnąć -20% zniżki i gratis!',
            },
            {
              threshold: 1,
              title: 'Jesteś na dobrej drodze!',
              description:
                'Jeszcze tylko [amount_to_next_threshold] zł i zgarniasz -[next_threshold_discount]% [another_gift_message]',
            },
            {
              threshold: 75,
              title: 'Jesteś na dobrej drodze!',
              description:
                'Jeszcze tylko [amount_to_next_threshold] zł i zgarniasz -[next_threshold_discount]% [another_gift_message]',
            },
            {
              threshold: 200,
              title: 'Twoja zniżka rośnie!',
              description: 'Jeszcze tylko [amount_to_next_threshold] zł i zgarniasz -[next_threshold_discount]%!',
            },
            {
              threshold: 300,
              title: 'Twoja zniżka rośnie!',
              description:
                'Jeszcze tylko [amount_to_next_threshold] zł i zgarniasz -[next_threshold_discount]% [another_gift_message]',
            },
            {
              threshold: 450,
              title: 'Gratulacje, masz już wszystko!',
              description: 'Masz maksymalny rabat i trzy prezenty. Jest moc!',
            },
          ];

          const renderWidgetCopy = (
            originalTotalPrice,
            amountToNextThreshold,
            nextThresholdDiscount,
            nextStepHasGift
          ) => {
            const current = schema.find((item, i, arr) =>
              item.threshold <= originalTotalPrice && ++i < arr.length ? arr[i++]?.threshold > originalTotalPrice : true
            );

            const index = schema.indexOf(current);

            console.log('index', index);

            const wrap = (text) => `<span>${text}</span>`;

            const changeContent = (el, source) => {
              if (el) {
                el.innerHTML = source
                  .replace('[amount_to_next_threshold]', wrap(amountToNextThreshold))
                  .replace('[next_threshold_discount]', wrap(nextThresholdDiscount))
                  .replace('[another_gift_message]', index === 1 ? JUST_Gift : nextStepHasGift ? ANOTHER_Gift : '');
              }
            };

            if (current) {
              const { title, description } = current;
              changeContent(progressTitle, title);
              changeContent(schemaProgressInfo, description);
            }
          };

          const handleElements = (hasDiscount) => {
            if (hasDiscount) {
              if (progressInfoText) progressInfoText.classList.remove('hidden');
              if (progressInfoEmpty) progressInfoEmpty.classList.add('hidden');
            } else {
              if (progressInfoText) progressInfoText.classList.add('hidden');
              if (progressInfoEmpty) progressInfoEmpty.classList.remove('hidden');
            }
            if (progressInfoFull) progressInfoFull.classList.add('hidden');
          };
          const setDiscountGapContent = (text) => {
            discountGapElem.forEach((el) => (el.textContent = text));
          };

          if (Rebuy.SmartCart.cart.items.length === 0) {
            progressWrapper.style.marginTop = '10px';
          } else {
            progressWrapper.style.marginTop = '20px';
          }

          let excludedProductsValue = Rebuy.SmartCart.cart.items.map((item) => {
            if ([9670253740367, 7037275144244, 15448229052751].includes(item.product_id)) {
              return item.price * item.quantity;
            } else {
              return null;
            }
          });

          let vouchersAmount = 0;
          excludedProductsValue.filter(Boolean).forEach((el) => (vouchersAmount += el));

          let originalTotalPrice = (Rebuy.SmartCart.cart.original_total_price - vouchersAmount) / 100;

          let currentTier = discountTiers[0];
          let lastTier = discountTiers[discountTiers.length - 1];

          for (let i = 1; i < discountTiers.length; i++) {
            if (originalTotalPrice >= discountTiers[i].amount) {
              currentTier = discountTiers[i];
            } else {
              break;
            }
          }

          document.querySelectorAll('.yk-step-extra').forEach((el) => el.classList.add('hidden'));
          const extraElement = document.querySelector(
            `[data-step="${discountTiers.indexOf(currentTier)}"].yk-step-extra`
          );
          if (extraElement) {
            extraElement.classList.remove('hidden');
          }

          let nextTier = discountTiers.find((tier) => originalTotalPrice < tier.amount);

          if (!nextTier) {
            nextTier = discountTiers[discountTiers.length - 1];
          }

          handleElements(currentTier.discount > 0);
          // currentDiscountElem.textContent = `${currentTier.discount}%`;

          if (lastTier) {
            const bar = document.querySelector('.progress-info-progress-bar');
            bar.style.width = `${Math.min((originalTotalPrice / lastTier.amount) * 100, 100)}%`;
          }

          if (milestoneElems) {
            milestoneElems.forEach((milestone) => {
              const discountValue = parseInt(milestone.getAttribute('data-discount'), 10);
              const thresholdValue = parseInt(milestone.getAttribute('data-amount'), 10);

              if (originalTotalPrice >= thresholdValue) {
                milestone.classList.add('milestone-active');
              } else {
                milestone.classList.remove('milestone-active');
              }

              if (discountValue === currentTier.discount) {
                milestone.classList.add('animation-pulse');
              } else {
                milestone.classList.remove('animation-pulse');
              }
            });
          }

          if (originalTotalPrice >= currentTier.amount) {
            const maxAmount = discountTiers[discountTiers.length - 1].amount;
            progress = (originalTotalPrice / maxAmount) * 100;
          }

          progressBar.style.width = `${Math.min(progress, 100)}%`;

          if (discountTotalValue) {
            discountTotalValue.textContent = '-' + convertDotPriceToComaPrice(Rebuy.SmartCart.cart.total_discount);
          }

          renderWidgetCopy(
            originalTotalPrice,
            (nextTier.amount - originalTotalPrice).toFixed(2).replace('.', ','),
            nextTier.discount,
            nextTier?.hasGift
          );

          if (originalTotalPrice < nextTier.amount) {
            if (discountGapElem) setDiscountGapContent();

            if (nextDiscountElem) nextDiscountElem.textContent = `-${nextTier.discount}%`;
          } else {
            if (progressInfoText) progressInfoText.classList.add('hidden');
            if (progressInfoEmpty) progressInfoEmpty.classList.add('hidden');
            if (progressInfoFull) progressInfoFull.classList.remove('hidden');
            if (discountGapElem) setDiscountGapContent('0');
            if (nextDiscountElem) nextDiscountElem.textContent = `-${nextTier.discount}%`;
          }
        }, 100);
      };

      // USAGE rebuy:smartcart.show
      const cartCopyText = async (code) => {
        const promotionText = document.querySelector('.smart-cart-promotion-banner span.code');

        try {
          await navigator.clipboard.writeText(code);
          promotionText.innerHTML = 'SKOPIOWANO';
          setTimeout(() => {
            const content = `${code} <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 12 12" fill="none">
                    <g clip-path="url(#clip0_1757_4792)">
                    <path d="M4 5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H9C9.26522 4 9.51957 4.10536 9.70711 4.29289C9.89464 4.48043 10 4.73478 10 5V9C10 9.26522 9.89464 9.51957 9.70711 9.70711C9.51957 9.89464 9.26522 10 9 10H5C4.73478 10 4.48043 9.89464 4.29289 9.70711C4.10536 9.51957 4 9.26522 4 9V5Z" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 4V3C8 2.73478 7.89464 2.48043 7.70711 2.29289C7.51957 2.10536 7.26522 2 7 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V7C2 7.26522 2.10536 7.51957 2.29289 7.70711C2.48043 7.89464 2.73478 8 3 8H4" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_1757_4792">
                    <rect width="12" height="12" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>`;
            promotionText.innerHTML = '';
            promotionText.insertAdjacentHTML('afterbegin', content);
          }, 2000);

          console.log('Content copied to clipboard');
        } catch (err) {
          console.error('Failed to copy: ', err);
        }
      };

      const handleDefaultProgressBarVisibility = () => {
        const stickyDelivery = document.querySelector('#sticky-delivery');
        const flyoutCartContent = document.querySelector('#flyout-cart-content');

        const cartData = JSON.parse(document.getElementById('SmartCartJson').textContent);
        const hideProgress = cartData?.hide_default_progress_bar;

        if (!hideProgress) return;

        if (stickyDelivery) stickyDelivery.classList.add('!hidden');
        if (flyoutCartContent) flyoutCartContent.style.padding = '0';
      };

      const handleDigitalProducts = () => {
        setTimeout(function () {
          let deliveryPrice = document.querySelector(
            '.rebuy-cart__flyout-footer .rebuy-cart__flyout-subtotal-amount--delivery-price'
          );

          let giftWrapper = document.querySelector('.rebuy-cart__flyout-wrap-gift');
          let giftWrapperSummary = document.querySelector('.rebuy-cart__flyout-wrap-gift summary');
          let giftWrapperDetails = document.querySelector('.rebuy-cart__flyout-wrap-gift details');

          let deliverPriceContainer = document.querySelectorAll('.rebuy-cart__flyout-subtotal');

          deliverPriceContainerEbook = deliverPriceContainer[1];

          let totalAmount = document.querySelector('.total-row--amount');

          let deliveryAdditionalInfo = document.querySelector('.delivery-additional-info');

          let totalProductsWithoutDelivery = document.querySelector(
            '.rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount'
          );

          let cartItems = document.querySelectorAll('.rebuy-cart__flyout-item');
          let onlyDigitals = !Array.from(cartItems).some((item) => !item.classList.contains('tag-digital'));
          const wrapGiftSchema = window.getShemaDataItem ? window.getShemaDataItem('wrap_gift') : null;
          const wrapGiftVariantId = wrapGiftSchema?.variant_id;
          const rebuyCartItems = Rebuy.Cart?.cart?.items || [];
          const cartItemsWithoutWrapGift = wrapGiftVariantId
            ? rebuyCartItems.filter((item) => item.variant_id !== wrapGiftVariantId)
            : rebuyCartItems;
          const onlyGiftSetGratisOrDigitalProducts =
            cartItemsWithoutWrapGift.length > 0 &&
            cartItemsWithoutWrapGift.every(({ product }) => {
              const tags = product?.tags || [];
              return (
                tags.includes('pakowane_na_prezent') || tags.includes('gratis_product') || tags.includes('digital')
              );
            });
          const shouldHideGiftWrap = onlyDigitals || onlyGiftSetGratisOrDigitalProducts;

          if (onlyDigitals && totalProductsWithoutDelivery) {
            if (deliveryAdditionalInfo) {
              deliveryAdditionalInfo.innerText = 'Natychmiast';
            }

            if (totalAmount) {
              totalAmount.innerText = totalProductsWithoutDelivery.innerText;
            }

            if (deliveryPrice) {
              deliveryPrice.innerHTML = 'Darmowa';
            }
          } else {
            if (Rebuy.SmartCart.hasFreeShipping()) {
              if (deliveryPrice) {
                deliveryPrice.innerHTML = 'Darmowa';
              }
            } else {
              if (deliveryPrice) {
                deliveryPrice.innerHTML = '15,99 zł';
              }
            }

            if (deliveryAdditionalInfo) {
              deliveryAdditionalInfo.innerText = 'Za 1-2 dni u Ciebie';
            }
          }

          if (giftWrapper) {
            if (shouldHideGiftWrap) {
              giftWrapper.style.position = 'absolute';
              giftWrapper.style.visibility = 'hidden';
            } else {
              giftWrapper.style.position = 'static';
              giftWrapper.style.visibility = 'visible';
            }
          }

          if (shouldHideGiftWrap && giftWrapperDetails && giftWrapperDetails.hasAttribute('open')) {
            if (giftWrapperSummary) giftWrapperSummary.click();
          }
        }, 50);
      };

      const checkHasSubscription = () => {
        setTimeout(() => {
          let hasSub = false;
          let SubTotal = 0;
          let NotSubTotal = 0;
          let FreeSub = window.ykFreeShippingSubDecimal;
          let FreeNotSub = window.ykFreeShippingDecimal;
          let RemainFreeSub = window.ykFreeShippingSub;
          let RemainFreeNotSub = window.ykFreeShipping;
          let CartTotal = 0;
          let RemainCartTotal = window.ykFreeShipping;
          let FreeCartTotal = window.ykFreeShippingDecimal;
          let fullGratis = false;

          Rebuy.Cart.cart.items.forEach((variant) => {
            const { product, price, quantity, discounted_price } = variant;
            if (product?.subscription) {
              hasSub = true;
              SubTotal += discounted_price * quantity;
            } else {
              NotSubTotal += discounted_price * quantity;
            }
          });

          if (
            Rebuy.Cart.cart.items_subtotal_price === Rebuy.Cart.cart.total_discount &&
            Rebuy.Cart.cart.total_price === 0
          ) {
            fullGratis = true;
          }

          if (fullGratis) {
            const totalAmount = document.querySelector('.rebuy-cart__flyout-subtotal-amount.total-row--amount');
            if (totalAmount) {
              totalAmount.innerText = '0,00 zł';
            }
          }

          CartTotal = SubTotal + NotSubTotal;

          RemainFreeSub = ((FreeSub - SubTotal) / 100).toFixed(2);
          const remainSubsToFreeDelivery = RemainFreeSub.replace('.', ',');

          RemainCartTotal = ((FreeCartTotal - Rebuy.SmartCart.cart.total_price) / 100).toFixed(2);
          const remainOnetimesToFreeDelivery = RemainCartTotal.replace('.', ',');

          Rebuy.SmartCart.settings.language.free_shipping_remaining = fullGratis
            ? `<div>Dodaj <span class="ivy-shipping-amount">${window.ykFreeShippingSub} zł</span> w produktach subskrypcyjnych lub <span class="ivy-shipping-amount">${window.ykFreeShipping} zł</span> w produktach jednorazowych i nie płać za dostawę</div>`
            : `<div>Dodaj <span class="ivy-shipping-amount">${remainSubsToFreeDelivery} zł</span> w produktach subskrypcyjnych lub <span class="ivy-shipping-amount">${remainOnetimesToFreeDelivery} zł</span> w produktach jednorazowych i nie płać za dostawę</div>`;
          if (hasSub) {
            if (CartTotal < FreeCartTotal) {
              Rebuy.SmartCart.settings.free_shipping.minimum = window.ykFreeShippingSubDeciaml + NotSubTotal;
            } else {
              Rebuy.SmartCart.settings.free_shipping.minimum = window.ykFreeShippingDecimal;
            }
          } else {
            Rebuy.SmartCart.settings.free_shipping.minimum = window.ykFreeShippingDecimal;
          }
        }, 100);
      };

      const blockCheckoutButton = () => {
        const button = document.getElementById('checkout');
        if (button) {
          button.disabled = true;

          setTimeout(() => {
            button.disabled = false;
          }, 500);
        }
      };

      const changeItemQuantity = async (productId, quantity) => {
        const endpoint = '/cart/change.js';
        const data = {
          id: productId,
          quantity: quantity,
        };
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          });

          if (response.ok) {
            const cartItem = await response.json();
          } else {
            console.error('Błąd podczas dodawania do koszyka:', response.statusText);
          }
        } catch (error) {
          console.error('Wystąpił błąd:', error);
        }
      };

      const handleGiftWrap = () => {
        const increaseBtn = document.querySelector('.increase-button');
        const decreaseBtn = document.querySelector('.decrease-button');
        const quantityDisplay = document.querySelector('.quantity-display');
        const giftWrapPrice = document.querySelector('.rebuy-cart__flyout-wrap-gift-price');
        const giftWrapUnitPrice = 1000;
        const wrapGiftDetails = document.querySelector('.rebuy-cart__flyout-wrap-gift details');
        const textareaDetails = document.querySelector('.rebuy-cart__flyout-wrap-gift details textarea');
        const checkoutButton = document.querySelector('.rebuy-cart__flyout-actions button#checkout');
        const validationText = document.querySelector('.yk-wrap-gift-validation');
        const validationCharsLimit = document.querySelector('.yk-wrap-gift-chars-limit');
        let quantity = 1;

        const resetElementsState = () => {
          if (checkoutButton) {
            checkoutButton.disabled = false;
            if (textareaDetails) {
              textareaDetails.style.border = '0.5px solid #c7c7c7';
            }
            if (validationCharsLimit) {
              validationCharsLimit.style.display = 'none';
            }

            if (validationText) {
              validationText.style.color = '#757575';
            }
          }
        };

        const renderGiftWrapPrice = () => {
          if (giftWrapPrice) {
            giftWrapPrice.innerText = convertDotPriceToComaPrice(quantity * giftWrapUnitPrice);
          }
        };

        const textareaListener = () => {
          if (textareaDetails && textareaDetails.value.trim() === '') {
            checkoutButton.disabled = true;
            textareaDetails.style.border = '0.5px solid red';
            if (validationText) {
              validationText.style.color = 'red';
            }
          } else if (textareaDetails && textareaDetails.value.length === 327) {
            checkoutButton.disabled = true;
            textareaDetails.style.border = '0.5px solid red';
            if (validationCharsLimit) {
              validationCharsLimit.style.display = 'block';
            }
          } else {
            resetElementsState();
          }
        };

        if (textareaDetails) {
          textareaDetails.addEventListener('input', textareaListener);
        }
        // click na disabled checkout btn
        document.addEventListener('click', (event) => {
          if (
            giftWrapPrice &&
            !giftWrapPrice.contains(event.target) &&
            event.target.classList.contains('rebuy-cart__flyout-actions')
          ) {
            if (textareaDetails.value.length === 0) {
              textareaDetails.style.border = '0.5px solid red';
              validationText.style.color = 'red';
            }
          }
        });

        const productId = '40497072996404';
        if (wrapGiftDetails && wrapGiftDetails.open) {
          if (textareaDetails.value.length === 0 && checkoutButton) {
            checkoutButton.disabled = true;
          } else {
            checkoutButton.disabled = false;
          }

          const giftWrap = Rebuy.SmartCart.cart.items.find((i) => i.id === Number(productId));

          quantity = giftWrap?.quantity || 1;

          const updateDecreaseButtonState = () => {
            decreaseBtn.disabled = quantity <= 1;
          };

          quantityDisplay.textContent = quantity;
          renderGiftWrapPrice();

          increaseBtn?.removeEventListener('click', increaseBtn._listener);
          decreaseBtn?.removeEventListener('click', decreaseBtn._listener);

          if (increaseBtn && decreaseBtn && quantityDisplay) {
            const increaseListener = () => {
              quantity += 1;
              quantityDisplay.textContent = quantity;

              const icon = increaseBtn.querySelector('i');
              const loader = increaseBtn.querySelector('.loader');
              icon.style.display = 'none';
              loader.style.display = 'inline-block';

              increaseBtn.disabled = true;

              changeItemQuantity(productId, quantity);

              setTimeout(() => {
                renderGiftWrapPrice();
                icon.style.display = 'block';
                loader.style.display = 'none';

                increaseBtn.disabled = false;
              }, 1500);
            };

            const decreaseListener = () => {
              if (quantity > 1) {
                quantity -= 1;
                quantityDisplay.textContent = quantity;
                updateDecreaseButtonState();

                const icon = decreaseBtn.querySelector('i');
                const loader = decreaseBtn.querySelector('.loader');
                icon.style.display = 'none';
                loader.style.display = 'inline-block';

                decreaseBtn.disabled = true;

                changeItemQuantity(productId, quantity);

                setTimeout(() => {
                  renderGiftWrapPrice();
                  icon.style.display = 'block';
                  loader.style.display = 'none';
                  decreaseBtn.disabled = false;
                }, 1500);
              }
            };

            increaseBtn._listener = increaseListener;
            decreaseBtn._listener = decreaseListener;

            increaseBtn.addEventListener('click', increaseListener);
            decreaseBtn.addEventListener('click', decreaseListener);

            updateDecreaseButtonState();
          }
        } else {
          quantity = 1;
          renderGiftWrapPrice();
          if (quantityDisplay) quantityDisplay.innerText = 1;
          resetElementsState();
        }
      };

      const processedLinks = new Set();
      const assignEventListenersToProductsInCart = () => {
        setTimeout(() => {
          const cartItemTitle = document.querySelectorAll('.rebuy-cart__flyout-item-info-first a');

          [...cartItemTitle].forEach((link, index) => {
            if (processedLinks.has(link)) return;
            processedLinks.add(link);

            let productAltText = link.getAttribute('alt');

            if (productAltText) {
              productAltText = productAltText.replace(/View\s+/i, '').trim();
            }

            const data = {
              event: 'product_tile_clicked',
              section: 'shopping_basket',
              element: 'small_product_tile',
              element_value: productAltText,
              interaction_type: 'click',
            };

            link.addEventListener('click', async (ev) => {
              ev.preventDefault();
              await dataLayerPromise(data);
              continueLinkClickEvent(ev, link.href);
            });
          });

          const cartItemImg = document.querySelectorAll('.rebuy-cart__flyout-item-media a');

          [...cartItemImg].forEach((link) => {
            if (processedLinks.has(link)) return;
            processedLinks.add(link);
            const img = link.querySelector('img');
            let imageAltText = img.getAttribute('alt');
            if (imageAltText) {
              imageAltText = imageAltText.replace(/View\s+/i, '').trim();
            }

            link.addEventListener('click', async (ev) => {
              ev.preventDefault();

              const data = {
                event: 'product_tile_clicked',
                section: 'shopping_basket',
                element: 'small_product_tile',
                element_value: imageAltText,
                interaction_type: 'click',
              };

              await dataLayerPromise(data);
              continueLinkClickEvent(ev, link.href);
            });
          });
        }, 500);
      };

      const assignEventListenersToRebuyWidgets = () => {
        setTimeout(() => {
          const cartRecommendedProductTitles = document.querySelectorAll(
            '#rebuy-widget-175240 .rebuy-product-right-container .rebuy-product-info a'
          );

          if (cartRecommendedProductTitles.length) {
            cartRecommendedProductTitles.forEach((link) => {
              if (processedLinks.has(link)) return;
              processedLinks.add(link);
              let productAltText = link.getAttribute('alt');

              if (productAltText) {
                productAltText = productAltText.replace(/View\s+/i, '').trim();
              }

              const data = {
                event: 'product_tile_clicked',
                device_type: deviceType,
                user_id: window.customerData?.id ? window.customerData?.id : '',
                section: 'shopping_basket_recommended',
                element: 'medium_product_tile',
                element_value: productAltText,
                interaction_type: 'click',
              };

              link.addEventListener('click', (ev) => {
                ev.preventDefault();

                dataLayer.push(data);
              });
            });
          }

          const cartRecommendedProductImages = document.querySelectorAll('#rebuy-widget-175240 .rebuy-product-media a');

          if (cartRecommendedProductImages.length) {
            cartRecommendedProductImages.forEach((link) => {
              if (processedLinks.has(link)) return;
              processedLinks.add(link);

              const img = link.querySelector('img');
              let imageAltText = img.getAttribute('alt');
              if (imageAltText) {
                imageAltText = imageAltText.replace(/View\s+/i, '').trim();
              }

              link.addEventListener('click', (ev) => {
                ev.preventDefault();

                const data = {
                  event: 'product_tile_clicked',
                  device_type: deviceType,
                  user_id: window.customerData?.id ? window.customerData?.id : '',
                  section: 'shopping_basket_recommended',
                  element: 'medium_product_tile',
                  element_value: imageAltText,
                  interaction_type: 'click',
                };

                dataLayer.push(data);
              });
            });
          }
        }, 1000);
      };

      const updateDiscountAmount = () => {
        setTimeout(() => {
          const discountWrapper = document.querySelector('.yk-discount-summary');
          const discountTotalValue = document.getElementById('yk-total_discount');
          const totalDiscount = Rebuy.SmartCart.cart.total_discount > 0;

          if (discountTotalValue && totalDiscount && discountWrapper) {
            discountWrapper.style.display = 'flex';
            discountTotalValue.textContent = '-' + convertDotPriceToComaPrice(Rebuy.SmartCart.cart.total_discount);
          } else {
            if (discountWrapper) {
              discountWrapper.style.display = 'none';
            }
          }
        }, 100);
      };

      const handleChangeOnetimesSellingPlan = () => {
        setTimeout(() => {
          Rebuy.SmartCart.cart.items.forEach((item) => {
            if (item.product?.subscription_frequency === 'Dostawa co 30 Dni') {
              const select = document.querySelector(`.product-${item.handle} select.rebuy-select`);
              if (select) {
                select.value = 'onetime';
                select.dispatchEvent(new Event('change'));
              }
            }
          });
        }, 1000);
      };

      function y(t) {
        document.addEventListener('rebuy:smartcart.ready', () => {
          checkHasSubscription();
          handleAddElementsToSellingPlanTitles();
          handleGiftWrap();
          updateDiscountAmount();
          handleDefaultProgressBarVisibility();
          updateProgressBar();
          assignEventListenersToProductsInCart();
          handleDigitalProducts();

          !0 === t && u();
          const e = '[data-cart-icon]';
          document.querySelectorAll(e).forEach((t) => {
            document.addEventListener('rebuy:cart.ready', () => s(t)),
              t.addEventListener('click', u),
              void 0 !== Rebuy.Cart.cart.items && l();
          }),
            document.addEventListener('rebuy:cart.change', () => {
              rebuyUpdateValuesAfterDiscount();
              setTimeout(displayOriginalPriceInProductList, 200);
              handleDisplayPromotionBar();
              handleAddElementsToSellingPlanTitles();
              updateDiscountAmount();
              updateProgressBar();
              handleDigitalProducts();
              document.querySelectorAll(e).forEach((t) => s(t)), void 0 !== Rebuy.Cart.cart.items && l();
            }),
            document.addEventListener('rebuy:cart.enriched', (event) => {
              checkHasSubscription();
              handleGiftWrap();
              updateDiscountAmount();
              handleDisplayPromotionBar();
              assignEventListenersToProductsInCart();
              setTimeout(displayOriginalPriceInProductList, 200);
              assignEventListenersToRebuyWidgets();
              handleDefaultProgressBarVisibility();
              handleChangeOnetimesSellingPlan();
              updateProgressBar();
            }),
            document.addEventListener('rebuy:smartcart.show', () => {
              rebuyUpdateValuesAfterDiscount();
              setTimeout(displayOriginalPriceInProductList, 200);
              handleDisplayPromotionBar();
              checkHasSubscription();
              updateProgressBar();
              handleGiftWrap();
              updateDiscountAmount();
              handleChangeOnetimesSellingPlan();
              handleDefaultProgressBarVisibility();
              document.querySelector('body').classList.add('rebuy-smartcart-opened');

              let rebuyButton = document.querySelector('.rebuy-cart__checkout-button');

              if (rebuyButton) {
                const smartCartBtn = rebuyButton.querySelector('span');
                if (smartCartBtn) {
                  smartCartBtn.innerText = 'PRZEJDŹ DO KASY';
                }

                rebuyButton.addEventListener('click', () => {
                  let selectElements2 = document.querySelectorAll(
                    '#rebuy-widget-87968 .rebuy-product-actions .subscription-frequency .rebuy-select'
                  );
                  processSelectElements();
                  function processSelectElements() {
                    if (selectElements2.length > 0) {
                      selectElements2.forEach((selectElement2) => {
                        checkAndModifySelect(selectElement2);
                      });
                    }
                  }

                  function checkAndModifySelect(selectElement2) {
                    if (selectElement2) {
                      let newOptionsTexts = [
                        'co 1 miesiąc',
                        'co 2 miesiące',
                        'co 3 miesiące',
                        'co 4 miesiące',
                        'co 5 miesięcy',
                        'co 6 miesięcy',
                      ];
                      let options = selectElement2.querySelectorAll('option');

                      options.forEach((option, index) => {
                        option.textContent = newOptionsTexts[index];
                      });
                    }
                  }
                });
              }
            }),
            document.addEventListener('rebuy:smartcart.hide', () =>
              document.querySelector('body').classList.remove('rebuy-smartcart-opened')
            );
        });
      }
      function p() {
        return 'object' == typeof Rebuy;
      }
      function f(t) {
        const { sectionId: e } = t;
        return 'smart-cart' === e;
      }
      function m(t) {
        void 0 === t ? Rebuy.SmartCart.hide() : u();
      }
      function w(t) {
        const { detail: e } = t;
        f(e) && p() ? m(null == e ? void 0 : e.load) : f(e) && !p() && y(!0);
      }
      function h() {
        if ('object' == typeof globalThis.freeForYou) {
          return (function (t) {
            return d(this, null, function* () {
              return (
                0 !== Object.keys(t).length &&
                (yield fetch(`${Shopify.routes.root}cart/update`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ attributes: t }),
                }),
                !0)
              );
            });
          })(
            globalThis.freeForYou.reduce((t, n) => {
              const i = Number(n.minimum_price) <= Rebuy.SmartCart.cart.total_price ? n.title : '';
              return (o = c({}, t)), (a = { [`Free For You - ${n.id}`]: i }), e(o, r(a));
              var o, a;
            }, {})
          );
        }
        return !0;
      }
      (window.wrapGiftDescription = ''),
        (window.getShemaDataItem = (t) => {
          const e = (function () {
            const t = document.getElementById('SmartCartJson');
            if (!t || !t.innerHTML.length) return !1;
            try {
              return JSON.parse(t.innerHTML);
            } catch (t) {
              return !1;
            }
          })();
          return void 0 === e[t] ? '' : e[t];
        }),
        (window.percentPriceDiscount = (t, e) => {
          const r = 100 * Number(t);
          return -1 * ((100 * (r - Number(e))) / r).toFixed(0) + '%';
        }),
        (window.hasFreeForYou = () => {
          const t = window.getShemaDataItem('free_for_you');
          if ('object' != typeof t) return !1;
          globalThis.freeForYou = t;
          const e = t.map((t) => Number(t.minimum_price));
          return window.itemMeetingCondition(e);
        }),
        (window.itemMeetingCondition = (t) => {
          const e = Rebuy.SmartCart.cart.total_price;
          return void 0 !== t.find((t) => Number(t) <= e);
        }),
        (window.cartHasWrapGift = () =>
          !!Rebuy.Cart.items().find((t) => t.variant_id === window.getShemaDataItem('wrap_gift').variant_id)),
        (window.wrapGiftSetToCart = () =>
          d(this, null, function* () {
            const t = window.getShemaDataItem('wrap_gift');
            if ('' === t) return !1;

            const e = {
              name: 'add.js',
              body: { items: [{ id: t.variant_id, quantity: 1 }] },
            };
            return (
              window.cartHasWrapGift() && ((e.name = 'update.js'), (e.body = { updates: { [t.variant_id]: 0 } })),
              yield fetch(`${Shopify.routes.root}cart/${e.name}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(e.body),
              }),
              Rebuy.SmartCart.view.updateTermsCheck(),
              !0
            );
          })),
        (window.setWrapGiftDescription = () => {
          var t;
          const e = window.getShemaDataItem('wrap_gift').property_key,
            r = window.getShemaDataItem('wrap_gift').variant_id,
            n = null == (t = Rebuy.Cart.items().find((t) => t.variant_id === r)) ? void 0 : t.properties;
          n && n[e] && (window.wrapGiftDescription = n[e]);
        }),
        (window.checkoutBeforeSet = (t) =>
          d(this, null, function* () {
            yield (function () {
              return d(this, null, function* () {
                var t;
                if (!window.cartHasWrapGift()) return !1;
                const e = window.getShemaDataItem('wrap_gift').property_key,
                  r = window.getShemaDataItem('wrap_gift').variant_id,
                  n = null == (t = Rebuy.Cart.items().find((t) => t.variant_id === r)) ? void 0 : t.key;

                const giftWrapItem = Rebuy.Cart.items().find((t) => t.variant_id === r);
                const currentQuantity = giftWrapItem?.quantity || 1;
                return (
                  yield fetch(`${Shopify.routes.root}cart/change.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      id: n,
                      quantity: currentQuantity,
                      properties: {
                        [e]: window.wrapGiftDescription,
                      },
                    }),
                  }),
                  !0
                );
              });
            })(),
              yield h(),
              t();
          })),
        Shopify.designMode
          ? (document.addEventListener('shopify:section:select', w),
            document.addEventListener('shopify:section:deselect', w),
            document.addEventListener('shopify:block:select', w),
            document.addEventListener('shopify:block:deselect', w))
          : y(),
        (window.calculatingRefillQuantity = (t, e, r) => {
          var n;
          const i = Rebuy.SmartCart.cart.items,
            o = i.filter((t) => {
              var e;
              return null == (e = null == t ? void 0 : t.properties) ? void 0 : e._product_refile;
            });
          if (!o.length) return t(e);
          const a = Number(null == (n = null == e ? void 0 : e.properties) ? void 0 : n._product_refile),
            d = i.find((t) => t.id === a),
            u = o.find((t) => Number(t.properties._product_refile) === e.id),
            s = JSON.stringify({
              updates: c(
                c({ [e.key]: e.quantity + r }, d && { [d.key]: d.quantity + r }),
                u && { [u.key]: e.quantity + r }
              ),
            });
          return (
            fetch(`${Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: s,
            }).finally(() => Rebuy.SmartCart.view.updateTermsCheck()),
            !0
          );
        });
    },
  },
  (t) => {
    var e;
    (e = 8978), t((t.s = e));
  },
]);
window.scrollToOneTime = () => {
  const elToScroll = document.getElementById('one-time-purchase-plan');
  elToScroll.scrollIntoView({ behavior: 'smooth' });
};
window.shouldShowSubInfo = () => {
  const cartSubItems = Rebuy.SmartCart.cart.items.filter((item) => {
    return item.product?.has_subscription && !item.product.subscription;
  });
  return cartSubItems.length > 0;
};
window.cartSubSavings = () => {
  const cartSubItems = Rebuy.SmartCart.cart.items.filter((item) => {
    return item.product?.has_subscription && !item.product.subscription;
  });
  const amount = cartSubItems.reduce((prev, next) => {
    const nextAmount =
      next.quantity * Math.round((next.price * parseFloat(next.product.subscription_discount_amount)) / 100);
    return prev + Math.floor(nextAmount) / 100;
  }, 0);
  return amount % 1 !== 0 ? amount.toFixed(2) : amount;
};
window.predictedDelivery = () => {
  // const now = new Date();
  // const timeToCheck = new Date().setHours(15, 0, 0, 0);
  // const isAfterTimeToCheck = now > timeToCheck;
  // return now.getDay() === 5 || now.getDay() === 6 || now.getDay() === 0 || isAfterTimeToCheck ? "Za 1-2 dni u Ciebie" : "JUTRO u Ciebie";
  const alwaysShowFutureMessage = true;
  return alwaysShowFutureMessage ? 'Za 1-2 dni u Ciebie' : 'JUTRO u Ciebie';
};
window.shouldShowInfo = () => {
  const div = document.getElementById('flyout-cart-content');
  const info = document.getElementById('info-toggle');
  if (info && div) {
    div.addEventListener(
      'scroll',
      () => {
        if (div.scrollTop >= div.scrollHeight - div.clientHeight - 50 && info.classList.contains('visible')) {
          info.classList.remove('visible');
        } else if (div.scrollTop < div.scrollHeight - div.clientHeight - 50 && !info.classList.contains('visible')) {
          info.classList.add('visible');
        }
      },
      false
    );
  }
};
window.toggleDelivery = () => {
  const scrollableDiv = document.getElementById('flyout-cart-content');
  const element = document.getElementById('sticky-delivery');
  const root = document.getElementById('rebuy-cart');
  root?.style.setProperty('--header-height', element?.scrollHeight + 'px');
  let lastScrollPosition = 0;
  let stayOpen = false;

  function toggleSticky() {
    const scrollTop = scrollableDiv.scrollTop;

    const showSummaryAmount = (state) => {
      const stickyFooterTotalRowAmount = document.querySelector('.cart--total-row');
      if (stickyFooterTotalRowAmount && state === 'show') {
        stickyFooterTotalRowAmount.classList.add('show');
      } else if (stickyFooterTotalRowAmount && state === 'hide') {
        stickyFooterTotalRowAmount.classList.remove('show');
      }
    };

    const showHandler = (element) => {
      if (element.classList.contains('sticky')) return;
      showSummaryAmount('show');
      element.classList.add('sticky');
      element.classList.remove('hide-sticky');
    };

    const hideHandler = (element) => {
      if (stayOpen) return (stayOpen = false);

      element.classList.remove('sticky');
      element.classList.add('hide-sticky');
    };

    const wrapperScrollPosition = scrollableDiv.scrollHeight - scrollableDiv.clientHeight - scrollableDiv.scrollTop;

    if (element) {
      if (wrapperScrollPosition <= 1) {
        showHandler(element);
        return (stayOpen = true);
      }

      if (scrollTop !== 0) {
        if (scrollTop < lastScrollPosition) {
          showHandler(element);
          showSummaryAmount('hide');
        } else {
          hideHandler(element);
        }

        lastScrollPosition = scrollTop;
      } else {
        setTimeout(() => {
          if (scrollTop === 0) {
            element.classList.remove('hide-sticky', 'sticky');
          }
        }, 10);
      }
    }
  }

  if (scrollableDiv) {
    scrollableDiv.addEventListener('scroll', toggleSticky);
  }

  return 'sticky-delivery';
};

window.shouldShowUpgradePlanButton = () => {
  const scrollableDiv = document.getElementById('flyout-cart-content');
  const elToScroll = document.getElementById('one-time-purchase-plan');
  let show;
  if (elToScroll) {
    scrollableDiv.addEventListener('scroll', () => {
      const button = document.getElementById('upgrade-subscription-info-button');
      if (
        (scrollableDiv.scrollTop >= elToScroll.offsetTop && scrollableDiv.scrollTop <= elToScroll.offsetTop + 200) ||
        (scrollableDiv.scrollTop <= elToScroll.offsetTop && scrollableDiv.scrollTop >= elToScroll.offsetTop - 100)
      ) {
        if (button) {
          button.classList.add('hide');
        }
      } else {
        if (button) {
          button.classList.remove('hide');
        }
      }
    });
  }
  return true;
};

const scrollToTopOfCartAfterAddedProductFromRebuyWidget = () => {
  const cartWrapper = document.getElementById('flyout-cart-content');
  if (cartWrapper === null) return;
  const buttons = cartWrapper.querySelectorAll('.rebuy-button');

  buttons.forEach((button) => {
    button.onclick = () => {
      setTimeout(() => {
        cartWrapper.scrollTo({ top: 0, behavior: 'smooth' });
      }, 300);
    };
  });
};

document.addEventListener('rebuy:smartcart.ready', () =>
  setTimeout(scrollToTopOfCartAfterAddedProductFromRebuyWidget, 1000)
);

function disableRemoveButtonsTemporarily() {
  const buttons = document.querySelectorAll('.rebuy-cart__flyout-item-remove');
  if (!buttons || buttons.length === 0) return;
  buttons.forEach((btn) => (btn.disabled = true));
  setTimeout(() => {
    buttons.forEach((btn) => (btn.disabled = false));
  }, 1000);
}
function removeItemTracking(item) {
  dataLayer.push({
    event: 'remove_from_cart',
    ecommerce: {
      currency: 'PLN',
      value: item.final_price,
      items: [
        {
          subscription: item.product.subscription,
          item_sku: item.sku,
          item_id: item.product_id,
          item_name: item.product_title,
          affiliation: item.vendor,
          discount: item.line_level_total_discount,
          item_category: item.product.product_type,
          item_variant: item.variant_title,
          price: item.original_price,
          quantity: item.quantity,
        },
      ],
    },
  });

  const multipackDiscount = window.YkMultipackDiscount?.get(item);
  if (multipackDiscount?.percent && typeof dataLayerPromise === 'function') {
    dataLayerPromise({
      event: 'multipack_widget_interaction',
      section: 'cart',
      element: 'multipack_item',
      element_value: `${item.handle} - ${item.quantity}`,
      interaction_type: 'remove_from_cart',
    });
  }
}
